import styled, { css } from 'styled-components'
import { themeColor, themeFontFamily } from 'LibNeo'
import { Input } from 'antd'
import { LinkComponentStyled } from 'LibNeo/components/Basic/Link/styled'
import { LabelWrapper, Wrapper } from 'LibNeo/components/Basic/Label/TooltipLabel/styled'

interface TextAreaInputProps {
	hasError?: boolean
	requiredHighlight?: boolean
}

const TextAreaErrorCss = css`
	color: ${themeColor('pink', 5)};
	margin: 4px 0 0 0;
	font-size: 12px;
	line-height: 16px;
`

export const TextAreaError = styled.div`
	${() => TextAreaErrorCss}
`

export const TextAreaInput = styled(Input.TextArea)<TextAreaInputProps>`
	resize: none;
	padding: 9px 15px;
	border: 1px solid ${themeColor('gray', 3)};
	min-height: 20px;
	font-size: 14px;
	line-height: 20px;
	border-radius: 6px;
	color: ${themeColor('extraBackground3')};
	&::placeholder {
		color: ${themeColor('gray', 4)};
	}
	&:focus {
		box-shadow: none;
		border: 1px solid ${themeColor('emerald', 6)};
		${({ requiredHighlight }) =>
			requiredHighlight &&
			css`
				border: 1px solid ${themeColor('sun')};
			`}
	}
	&:hover {
		border-color: ${themeColor('gray', 5)};
	}
	&.ant-input-disabled {
		background: ${themeColor('gray', 1)};
		cursor: not-allowed;
		color: ${themeColor('gray', 6)};
		&:hover {
			background: ${themeColor('gray', 1)};
			border-color: ${themeColor('gray', 3)};
		}
	}

	${({ hasError }) =>
		hasError &&
		css`
			border: 1px solid ${themeColor('pink', 5)};
		`}
	${({ requiredHighlight }) =>
		requiredHighlight &&
		css`
			border: 1px solid ${themeColor('sun')};
		`}
`

export const TextArea = styled.div`
	display: flex;
	flex-direction: column;
	font-family: ${themeFontFamily('SBSansInterface')};

	textarea.ant-input {
		margin: initial;
	}

	${Wrapper} {
		${LinkComponentStyled},
		${LabelWrapper} {
			font-size: 12px;
			line-height: 20px;
		}
	}

	.has-error {
		.ant-form-explain {
			${() => TextAreaErrorCss}
		}

		textarea.ant-input {
			border-color: ${themeColor('pink', 5)};

			&:focus {
				box-shadow: none;
			}

			& .ant-input,
			& .ant-input:hover,
			& .ant-input:focus {
				border: 0;
				box-shadow: none;
			}
		}
	}
`
